import { shape, string } from 'prop-types';

const projectItem = shape({
    id: string.isRequired,
    title: string,
    item: string
});

export default projectItem;
